import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FiTrendingUp,
    FiUserCheck,
    FiPlus,
    FiTarget,
    FiBell,
    FiFileText,
    FiZap,
    FiHome,
} from 'react-icons/fi';
import { PageHeader } from '../../theme/components/PageHeader';
import { WelcomeHero } from './WelcomeHero';
import { BentoCard } from './BentoCard';
import './HomePage.css';

const HomePage = () => {
    const navigate = useNavigate();

    return (
        <div className="wp-wrapper">
            <PageHeader
                title="Home"
                icon={FiHome}
            />

            <div className="wp-container">
                {/* Bento grid — 12 columns on desktop, responsive collapse below. */}
                <div className="wp-bento wp-stagger">

                    {/* Hero (cols 1–8, rows 1–2) */}
                    <div className="wp-bento__slot wp-bento__slot--hero">
                        <WelcomeHero />
                    </div>

                    {/* Rapid Entry (cols 9–12, rows 1–2) */}
                    <div className="wp-bento__slot wp-bento__slot--rapid">
                        <BentoCard
                            variant="sky"
                            icon={FiZap}
                            title="Rapid Entry"
                            description="Quick record growth and vaccines."
                            meta="Fast"
                            watermark={FiZap}
                            footerLabel="Open Rapid Entry"
                            onClick={() => navigate('/rapid-entry')}
                        />
                    </div>

                    {/* Add New Child (cols 9–12, rows 3–4) */}
                    <div className="wp-bento__slot wp-bento__slot--add">
                        <BentoCard
                            variant="emerald"
                            icon={FiPlus}
                            title="Add New Child"
                            description="Register a new or existing child in the system."
                            watermark={FiTarget}
                            footerLabel="Start Registration"
                            onClick={() => navigate('/add-child')}
                        />
                    </div>

                    {/* Profiles (cols 1–4, row 3) */}
                    <div className="wp-bento__slot wp-bento__slot--profiles">
                        <BentoCard
                            variant="tile"
                            icon={FiUserCheck}
                            title="Profiles"
                            description="All children's profiles."
                            onClick={() => navigate('/profiles')}
                            style={{ '--card-accent': 'var(--pt-primary)' }}
                        />
                    </div>

                    {/* Dashboard (cols 5–8, row 3) */}
                    <div className="wp-bento__slot wp-bento__slot--dashboard">
                        <BentoCard
                            variant="tile"
                            icon={FiTrendingUp}
                            title="Dashboard"
                            description="View clinic statistics & trends."
                            onClick={() => navigate('/dashboard')}
                            style={{ '--card-accent': 'var(--pt-secondary)' }}
                        />
                    </div>

                    {/* Reminders (cols 1–4, row 4) */}
                    <div className="wp-bento__slot wp-bento__slot--reminders">
                        <BentoCard
                            variant="tile"
                            icon={FiBell}
                            title="Reminders"
                            description="Follow-ups."
                            onClick={() => navigate('/reminders')}
                            style={{ '--card-accent': 'var(--pt-error)' }}
                        />
                    </div>

                    {/* Reports (cols 5–8, row 4) */}
                    <div className="wp-bento__slot wp-bento__slot--reports">
                        <BentoCard
                            variant="tile"
                            icon={FiFileText}
                            title="Reports"
                            description="Generate reports here."
                            onClick={() => navigate('/reports')}
                            style={{ '--card-accent': '#9333ea' }}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default HomePage;
